<template>

    <div style="border-radius: inherit" class="overflow-hidden progress-bar-animation w-full h-1 bg-gray-200 dark:bg-gray-700">
        <div class="bg-indigo-400 h-1 progress-bar-animation-inner"></div>
    </div>

</template>

<script>
export default {
    name: "WorkingBar"
}
</script>

<style scoped>
@keyframes progressBarAnimation {
    0% {
        width: 0;
        float: left;
    }
    49% {
        width: 100%;
        float: left;
    }
    51% {
        width: 100%;
        float: right;
    }
    99% {
        width: 0;
        float: right;
    }
    100% {
        width: 0;
        float: left;
    }
}

.progress-bar-animation-inner{
    animation-duration: 3s;
    animation-name: progressBarAnimation;
    animation-iteration-count: infinite;
    animation-direction: normal;
}


</style>
